<template>
  <div>
    <template v-if="!loading.overall">
      <v-container>
        <!-- Settings Gear, no Gear -->
        <SettingsGear :showIcon="false" />
        <!-- One Logo / Slogan -->
        <div class="one-logo">
          <div class="one-logo-content">
            <img src="@/assets/logos/dime_logo_gold.png" />
          </div>
        </div>
        <!-- Content -->
        <div class="content">
          <div class="content-logo">
            <!-- <img src="@/assets/logos/dime_thinkhigher.png" /> -->
          </div>
          <!-- Login -->
          <div class="content-form">
            <form style="width: 100%" @submit.prevent>
              <div class="mb-3">
                <input
                  ref="EMAIL"
                  type="text"
                  :style="`border: 2px solid ${getAccentColor};`"
                  placeholder="EMAIL"
                  v-model.trim="payload.user.email"
                  class="form-control py-2 form-input"
                  autocomplete="on"
                  maxlength="128"
                />
              </div>
              <div class="mb-3" v-if="loginMode == 'login'">
                <input
                  ref="PASSWORD"
                  type="password"
                  :style="`border: 2px solid ${getAccentColor}; `"
                  placeholder="PASSWORD"
                  v-model.trim="payload.user.password"
                  class="form-control py-2 form-input"
                  autocomplete="off"
                  maxlength="20"
                />
              </div>
              <template>
                <div class="mb-5">
                  <!-- <button
                    class="text-white py-2 form-button"
                    :style="`background-color: ${
                      validSubmission ? 'grey' : getAccentColor
                    };`"
                    @click="traverse(loginMode)"
                    :disabled="validSubmission"
                  > -->
                  <button
                    class="text-white py-2 form-button"
                    :style="`background-color: ${getAccentColor};`"
                    @click="traverse(loginMode)"
                    :disabled="buttonDisabled"
                  >
                    <span class="form-span">
                      {{ !currentLoginMode ? "login" : "get verify code" }}
                    </span>
                  </button>
                  <div
                    v-show="!currentLoginMode"
                    class="text-white text-center py-2 text-uppercase"
                    style="margin-top: 8px"
                    @click="onClickForgot"
                  >
                    FORGOT EMAIL/PASSWORD?
                  </div>
                </div>
              </template>
            </form>
          </div>
        </div>
        <!-- Footer -->
        <div
          style="
            display: flex;
            height: 100%;
            align-items: center;
            justify-content: center;
            padding-bottom: 4vh;
          "
          ref="footerLogo"
        >
          <img style="height: 3.5em" src="@/assets/logos/one_logo_black.png" />
        </div>

        <div style="height: 10vh; text-align: center" ref="footer">
          <div
            style="
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: flex-start;
            "
          >
            <div class="row">
              <div
                class="col form-col"
                @click="
                  currentLoginMode = false;
                  traverse('switchLoginMode');
                "
              >
                <span
                  class="text-uppercase"
                  :style="`color: ${
                    currentLoginMode ? '#fff' : getActionColor
                  };`"
                  >login</span
                >
              </div>
              <div class="col">
                <label class="switch" @change="traverse('switchLoginMode')">
                  <input type="checkbox" v-model="currentLoginMode" />
                  <span class="slider round"></span>
                </label>
              </div>
              <div
                class="col form-col"
                @click="
                  currentLoginMode = true;
                  traverse('switchLoginMode');
                "
              >
                <span
                  class="text-uppercase"
                  :style="`color: ${
                    currentLoginMode ? getActionColor : '#fff'
                  };`"
                  >new user</span
                >
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </template>
    <template v-else> Loading... </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Toast } from "vant";

export default {
  name: "login",
  data() {
    return {
      loading: {
        overall: true,
      },
      loginMode: "login", //登录 login OR 注册 register
      currentLoginMode: false, // 登录方式 true：register false：login
      response: {},
      payload: {
        user: {
          email: "",
          password: "",
        },
      },
      defaultPhoneHeight: 0, //屏幕默认高度
      nowPhoneHeight: 0, //屏幕现在的高度
    };
  },
  created() {
    this.setup();
  },
  mounted() {
    this.defaultPhoneHeight = window.innerHeight;
    window.onresize = () => {
      this.nowPhoneHeight = window.innerHeight;
    };
  },

  methods: {
    ...mapActions([
      "_setLoginState",
      "_setLoginInfo",
      "_setRegisterEmail",
      "_setPresetInfo",
    ]),
    /* API Calls */
    // GET
    // POST
    /* Main */
    async setup() {
      if (window.localStorage.getItem("front-token")) {
        this.$router.replace({
          name: "device",
        });
        this._setLoginInfo(window.localStorage.getItem("userInfo"));
      } else {
        await this.setLoadingState(true);
        this._setRegisterEmail("");
        // //this.payload.user.email = this.payload.user.password = "";
        // // Methods
        await this.setLoadingState(false);
      }
    },
    traverse(action) {
      switch (action) {
        // 登录
        case "login":
          //#region 校验
          if (this.payload.user.email.length == 0) {
            this.$showTips({
              msg: "Input an e-mail",
            });
            // Toast.fail("Input an e-mail");
            this.$refs.EMAIL.focus();
            return;
          }
          if (!this.emailSet) {
            this.$showTips({ msg: "E-mail incorrectly formatted" });
            // Toast.fail("E-mail incorrectly formatted");
            this.$refs.EMAIL.focus();
            return;
          }
          if (this.payload.user.password.length == 0) {
            this.$showTips({ msg: "Input a password" });
            // Toast.fail("Input a password");
            this.$refs.PASSWORD.focus();
            return;
          }
          // if (this.payload.user.password.length < 6) {
          //   Toast.fail("Please enter your password.");
          //   this.$refs.PASSWORD.focus();
          //   return;
          // }

          //#endregion
          let params = {
            email: this.payload.user.email,
            password: this.payload.user.password,
          };
          this.showLoading("Loading...");
          this.$api.user
            .login(params)
            .then((res) => {
              this.hideLoading();
              if (res.code === 200) {
                window.localStorage.setItem("front-token", res.data.token);
                this._setRegisterEmail(this.payload.user.email);
                this._setLoginState(true);
                this._setLoginInfo(res.data);
                window.localStorage.setItem("userInfo", res.data);
                this.$router.replace({ name: "pair_main" });
              } else {
                window.localStorage.setItem("front-token", "");
                this._setRegisterEmail("");
                this._setLoginState(false);
                this._setLoginInfo(null);
                this._setPresetInfo(null);

                this.$showTips({ msg: res.message });
                // Toast.fail(res.message);
                if (res.code === 514) {
                  this.payload.user.password = "";
                  this.$refs.PASSWORD.focus();
                }
              }
            })
            .catch((res) => {
              this.hideLoading();
              this.$showTips({ msg: res.message });
              // Toast.fail(res.message);
            });
          break;
        // 注册
        case "register":
          if (this.payload.user.email.length == 0) {
            this.$showTips({ msg: "Input an e-mail" });
            // Toast.fail("Input an e-mail");
            this.$refs.EMAIL.focus();
            return;
          }
          if (!this.emailSet) {
            this.$showTips({ msg: "E-mail incorrectly formatted" });
            // Toast.fail("E-mail incorrectly formatted");
            this.$refs.EMAIL.focus();
            return;
          }
          this.showLoading("Sending...");
          this.$api.user
            .sendEmailToRegister({ email: this.payload.user.email })
            .then((res) => {
              this.hideLoading();
              if (res.data.code === 200) {
                this._setRegisterEmail(this.payload.user.email);
                // Toast.success(res.data.message);
                this.$showTips({
                  msg: res.data.message,
                  duration: 3000,
                  showType: "info",
                });
                this.$router.push({
                  name: "verify_code",
                  params: {
                    type: "register", //注册
                  },
                });
              } else {
                this.$showTips({ msg: res.data.message });
                // Toast.fail(res.data.message);
              }
            })
            .catch((res) => {
              this.hideLoading();

              this.$showTips({ msg: res.message });
              // Toast.fail(res.message);
            });
          break;
        // 切换登录方式
        case "switchLoginMode":
          if (!this.currentLoginMode) {
            this.loginMode = "login";
          } else {
            this.loginMode = "register";
          }
          break;
      }
    },
    /* Misc */
    async setLoadingState(loadingState) {
      this.loading.overall = loadingState;
    },
    onClickForgot() {
      this.$router.push({ name: "getCode" });
    },
  },
  computed: {
    ...mapGetters([
      "getMainColor",
      "getAccentColor",
      "getLoginState",
      "getActionColor",
    ]),
    buttonDisabled() {
      if (!this.currentLoginMode) {
        // 登录
        if (
          this.payload.user.email.length == 0 ||
          this.payload.user.password.length == 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        // 注册
        if (this.payload.user.email.length == 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    emailSet() {
      var reg = /^([a-zA-Z]|[0-9]|\.|\-|\_)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      return reg.test(this.payload.user.email) ? true : false;
    },
    passwordSet() {
      return this.payload.user.password.length >= 6 &&
        this.payload.user.password.length <= 20
        ? true
        : false;
    },
    validUserLogin() {
      return this.emailSet && this.passwordSet ? true : false;
    },
    validRegister() {
      return this.emailSet ? true : false;
    },
    validSubmission() {
      return !this.currentLoginMode
        ? !this.validUserLogin
        : !this.validRegister;
    },
  },
  watch: {
    nowPhoneHeight: function () {
      if (this.defaultPhoneHeight != this.nowPhoneHeight) {
        //手机键盘被唤起了。
        this.$refs.footer.style.display = "none";
        this.$refs.footerLogo.style.display = "none";
      } else {
        //手机键盘被关闭了。
        this.$refs.footer.style.display = "block";
        this.$refs.footerLogo.style.display = "flex";
      }
    },
  },
};
</script>

<style lang="less" scoped>
::placeholder {
  color: white;
  text-align: center;
}

.one-logo {
  height: 15vh;

  .one-logo-content {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;

    img {
      height: 7em;
    }
  }
}

.content {
  height: 58vh;

  .content-logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: flex-end;
    height: 6.5em;

    img {
      height: 2.5em;
    }

    .content-form {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  }
}

.form-input {
  background-color: transparent;
  color: white;
  border-radius: 30px;
}

.form-button {
  border: none;
  width: 100%;
  border-radius: 30px;
  font-weight: 500;
}

.form-button:disabled {
  background: #959595 !important;
}

.form-span {
  text-transform: uppercase;
  font-size: 1.2em;
}

.form-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border: 2px solid #ffab00;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 3px;
  bottom: 3px;
  background-color: #ffab00;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:focus + .slider {
  box-shadow: 0 0 1px #ffab00;
}

input:checked + .slider:before {
  -webkit-transform: translateX(27px);
  -ms-transform: translateX(27px);
  transform: translateX(27px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
